import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../../components/layout/SiteShell";
import ContentPageLayout from "../../components/content/ContentPageLayout";
import SEO from "../../components/seo/SEO";
import WellnessDisclaimer from "../../components/content/WellnessDisclaimer";

const WAITLIST_MAIL = "mailto:info@mossmatrix.com?subject=Herbal%20Pantry%20waitlist";

export default function ComingSoonHerbalPantryPage() {
  const path = "/coming-soon/herbal-pantry";
  return (
    <SiteShell>
      <SEO
        title="Herbal Pantry | Coming soon | MossMatrix"
        description="Soon: selected powdered herbs, roots, and botanicals for home blending (MossMatrix Herbal Pantry). Waitlist only; not a full shop launch yet."
        path={path}
      />
      <ContentPageLayout
        eyebrow="Coming soon"
        title="Herbal Pantry"
        subtitle="Soon, you will be able to order selected powdered herbs and botanicals separately. Ideal if you like to blend at home."
      >
        <div className="max-w-3xl space-y-5 text-sm text-botanical/85 leading-relaxed mb-10">
          <p>
            We’re planning a future line of <strong className="text-forest font-medium">powdered herbs, roots, botanicals</strong>, and
            pantry-friendly formats (think blend-your-own packs or refill pouches) without complicating our gel launch today.
          </p>
          <p className="text-xs text-botanical/70">
            Nothing here is for sale yet. Join the waitlist if you want first notice when the Herbal Pantry opens.
          </p>
        </div>

        <div className="rounded-3xl border border-cream bg-offwhite p-8 text-center max-w-lg mx-auto mb-12">
          <p className="font-serif text-xl text-forest">Join the Herbal Pantry waitlist</p>
          <a
            href={WAITLIST_MAIL}
            className="mt-6 inline-flex rounded-full bg-forest text-cream px-8 py-3.5 text-sm font-medium hover:bg-botanical transition"
          >
            Email the waitlist
          </a>
        </div>

        <WellnessDisclaimer className="max-w-3xl mx-auto" />

        <p className="text-center text-sm text-botanical/70 mt-10">
          <Link to="/ingredients" className="underline hover:text-forest">
            Ingredient library
          </Link>
          {" · "}
          <Link to="/coming-soon/skin-range" className="underline hover:text-forest">
            Skin range (coming soon)
          </Link>
        </p>
      </ContentPageLayout>
    </SiteShell>
  );
}
